import script from "./CompareModeTopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareModeTopBar.vue?vue&type=script&setup=true&lang=ts"

import "./CompareModeTopBar.vue?vue&type=style&index=0&id=3f786d79&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f786d79"]])

export default __exports__